import React from 'react';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';

export default function ProjectsBasicInfoComponent({ onInnerBasicFormChange,
    libraryData, selectedProject }: any) {
    return (
        <><AccordionContainer
            child={
                <div className=' grid md:grid-cols-3 lg:grid-cols-3 gap-4'>

                    <InputContainer
                        label="Name"
                        name="Name"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'Name'
                            )
                        }}
                        type="text"
                        value={selectedProject?.Name}
                    />

                    <InputContainer
                        label="Description"
                        name="Description"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'Description'
                            )
                        }}
                        type="text"
                        value={selectedProject?.Description}
                    />

                    <InputContainer
                        label="Project Priority"
                        labelField="Text"
                        list={libraryData?.result?.ProjectPriority}
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'ProjectPriorityId',
                            )
                        }}
                        optionName="Choose Project Priority"
                        type="select"
                        value={selectedProject?.ProjectPriorityId}
                        valueField="Value"
                    />

                    <InputContainer
                        label="Project State"
                        labelField="Text"
                        list={libraryData?.result?.ProjectState}
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'ProjectStateId',
                            )
                        }}
                        optionName="Choose Project State"
                        type="select"
                        value={selectedProject?.ProjectStateId}
                        valueField="Value"
                    />

                    <InputContainer
                        label="Start Date"
                        labelField="StartDateTimeInUtc"
                        onValueChange={(event: any, newValue: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'StartDateTimeInUtc'
                            );
                        }}
                        type="date"
                        value={selectedProject?.StartDateTimeInUtc}
                    />

                     <InputContainer
                        label="End Date"
                        labelField="EndDateTimeInUtc"
                        onValueChange={(event: any, newValue: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'EndDateTimeInUtc'
                            );
                        }}
                        type="date"
                        value={selectedProject?.EndDateTimeInUtc}
                    />
                </div>
            }
            expandedPanel="userInfo"
            headerTitle="Basic Info"
        />
        </>
    )
}
